import React from 'react';
import loggedInLogo from '../../../../core/images/99designs-byVP-squarelogomark.svg';
import loggedOutLogo from '../../../../core/images/99designs-byVP-wordmark-blue.svg';
import { Role } from '../../consts';

interface Props {
    role: Role;
}

export default function Logo({ role }: Props) {
    const homeUrl = role === 'contest-holder' ? '/work' : '/';

    return (
        <div className="site-header__item site-header__item--branding">
            <a
                className="site-header__site-logo"
                href={homeUrl}
                title={__('99designs by Vistaprint')}
            >
                <div
                    className="site-header__site-logo__image"
                    dangerouslySetInnerHTML={{
                        __html: role === 'logged-out' ? loggedOutLogo : loggedInLogo,
                    }}
                    aria-label={__('99designs by Vistaprint')}
                />
            </a>
        </div>
    );
}
